import { Helmet } from "react-helmet-async";
import useGrapeshot from "@hooks/useGrapeshot";

export enum GrapeshotDisplayOptions {
  Meta = "meta",
  GTM = "gtm",
}

export type ArticleGrapeshotProps = {
  article_url: string;
  displayOptions: GrapeshotDisplayOptions;
};

export default function ArticleGrapeshot({
  article_url,
  displayOptions,
}: ArticleGrapeshotProps): React.ReactElement {
  const gs_channels = useGrapeshot(article_url).map((item) => item.name);

  switch (displayOptions) {
    case GrapeshotDisplayOptions.Meta:
      return (
        <Helmet>
          <script type="text/javascript">
            {`
        var gs_channels = ${JSON.stringify(gs_channels)};
         `}
          </script>
        </Helmet>
      );
    case GrapeshotDisplayOptions.GTM:
      return (
        <Helmet>
          <meta
            name="grapeshot_tag"
            id="grapeshot"
            data-testid="grapeshot"
            content={gs_channels.join(",")}
          />
          <script type="text/javascript">
            {`
        googletag.cmd.push(function() { googletag.pubads().setTargeting("gs_channels", ${JSON.stringify(gs_channels)});});
         `}
          </script>
        </Helmet>
      );
    default:
      return <></>;
  }
}
